import AlignCenter from "../../icons/AlignCenter";
import AlignLeft from "../../icons/AlignLeft";
import AlignRight from "../../icons/AlignRight";

export const ALIGNMENT_OPTIONS = [
  { icon: AlignLeft, value: "left" },
  { icon: AlignCenter, value: "center" },
  { icon: AlignRight, value: "right" },
];

export const BOOLEAN_OPTIONS = [
  { label: "Yes", i18n: "yes", value: true },
  { label: "No", i18n: "no", value: false },
];
